import { render, staticRenderFns } from "./QuestionsDisplay.vue?vue&type=template&id=30fd7ee3&scoped=true"
import script from "./QuestionsDisplay.vue?vue&type=script&lang=js"
export * from "./QuestionsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd7ee3",
  null
  
)

export default component.exports